import { LedeMetaConfig } from "@ui/context/component-config-context";

const ledeMetaConfig: LedeMetaConfig = {
  standard: {
    desktopAdSlot: "articleSponsorshipDesktop",
    mobileAdSlot: "articleSponsorshipMobileAndTablet",
  },
  specialSplit: {
    desktopAdSlot: "articleSponsorshipHeadlineAboveDesktop",
    mobileAdSlot: "articleSponsorshipHeadlineAboveMobileAndTablet",
  },
  specialFullWidth: {
    desktopAdSlot: "articleSponsorshipHeadlineAboveDesktop",
    mobileAdSlot: "articleSponsorshipHeadlineAboveMobileAndTablet",
  },
  overlay: {
    desktopAdSlot: "articleSponsorshipWhiteDesktop",
    mobileAdSlot: "articleSponsorshipWhiteMobileAndTablet",
  },
  fullWidth: {
    desktopAdSlot: "articleSponsorshipHeadlineAboveDesktop",
    mobileAdSlot: "articleSponsorshipHeadlineAboveMobileAndTablet",
  },
  split: {
    desktopAdSlot: "articleSponsorshipHeadlineAboveDesktop",
    mobileAdSlot: "articleSponsorshipHeadlineAboveMobileAndTablet",
  },
  inlineOnDesktop: false,
  inlineBylineTimestamp: false,
};

export default ledeMetaConfig;
